










































import { Vue, Component } from 'vue-property-decorator'
import { MutationTypes } from '@/store/mutations'
import { humanDate, filterFunc, getDisastersColor } from '@/lib/common'
import { DisasterDatum } from '@/lib/types'

@Component({
	name: 'TimeSelector',
	components: {}
})
export default class TimeSelector extends Vue {
	readonly humanDate = humanDate

	get cloudBlobDisastersOnly() {
		return this.$tStore.state.disasterFilter.cloudBandOnly
	}

	get seasons() {
		return this.$tStore.getters.seasons
	}

	get selectedEventIndex() {
		return this.$tStore.state.selectedEventIndex
	}

	get selectedSeasonIndex() {
		return this.$tStore.state.selectedSeasonIndex
	}

	get daysOfYear() {
		const days = []
		for (let i = 1; i <= 366; i++) {
			days.push(i)
		}
		return days
	}

	dayHasDisasters(disasters: DisasterDatum[] | undefined) {
		if (!disasters) return false
		return (
			disasters.filter(d => filterFunc(d, this.$tStore.state.disasterFilter))
				.length > 0
		)
	}

	dayHasMajorDisasters(disasters: DisasterDatum[] | undefined) {
		if (!disasters) return false
		return disasters.filter(d => d.major).length > 0
	}

	getDisasterColor(disasters: DisasterDatum[] | undefined) {
		if(!disasters) {
			return 'rgba(0,0,0,0)'
		}
		return getDisastersColor(
			disasters.filter(d => filterFunc(d, this.$tStore.state.disasterFilter))
		)
	}

	selectSeason(seasonIndex: number) {
		if (this.selectedSeasonIndex !== seasonIndex) {
			this.$tStore.commit(MutationTypes.SET_SELECTED_SEASON, seasonIndex)
			this.$tStore.commit(MutationTypes.SET_SELECTED_VIEW, 'season')
		}
	}
}
